'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import Branding from 'MeetingsBase/models/Branding';
import UIImage from 'UIComponents/image/UIImage';
import styled from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
var COMPANY_LOGO_USE = {
  EMAIL_FORM: 'email-form',
  BOOKING_CONTAINER: 'booking-container'
};
var CONTAINER_HEIGHT = '92px';
var IMAGE_HEIGHT = '76px';
var Logo = styled(UIImage).withConfig({
  displayName: "CompanyLogo__Logo",
  componentId: "sc-12w2rum-0"
})(["background-color:", ";max-height:", ";max-width:100%;"], GYPSUM, IMAGE_HEIGHT);

var CompanyLogo = function CompanyLogo(props) {
  var compact = props.compact,
      _props$branding = props.branding,
      logoUrl = _props$branding.logoUrl,
      logoAltText = _props$branding.logoAltText,
      companyName = _props$branding.companyName,
      heightOverride = props.heightOverride,
      use = props.use;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imageHasLoaded = _useState2[0],
      setImageHasLoaded = _useState2[1];

  useEffect(function () {
    var imageEl = document.getElementById("logo-landmark-" + use);
    var computedImageHeight = imageEl && getComputedStyle(imageEl, null).height;

    if (imageEl && imageHasLoaded && computedImageHeight === '0px') {
      imageEl.style.height = IMAGE_HEIGHT;
    }

    if (imageEl && heightOverride && use === COMPANY_LOGO_USE.EMAIL_FORM) {
      imageEl.style.maxHeight = heightOverride || IMAGE_HEIGHT;
    }
  }, [heightOverride, imageHasLoaded, use]);
  var hasLogo = Boolean(logoUrl);

  if (!hasLogo) {
    return null;
  }

  var classes = 'p-top-4' + (compact ? " m-bottom-4" : "");
  var alt = logoAltText;

  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('prebook.brandingAltText', {
        companyName: companyName
      });
    } else {
      alt = I18n.text('prebook.brandingAltTextNoCompany');
    }
  }

  return /*#__PURE__*/_jsx("div", {
    role: "banner",
    "aria-labelledby": "logo-landmark",
    className: classes,
    style: {
      CONTAINER_HEIGHT: CONTAINER_HEIGHT,
      background: GYPSUM
    },
    children: /*#__PURE__*/_jsx(Logo, {
      id: "logo-landmark-" + use,
      className: "m-x-auto",
      src: logoUrl,
      alt: alt,
      onLoad: function onLoad() {
        setImageHasLoaded(true);
      }
    })
  });
};

CompanyLogo.propTypes = {
  compact: PropTypes.bool,
  branding: PropTypes.instanceOf(Branding).isRequired,
  use: PropTypes.string,
  heightOverride: PropTypes.string
};
export default CompanyLogo;